var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarningYellow = function SvgIconWarningYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M3.003 21.42a1.127 1.127 0 0 1-.975-1.688L11.025 4.15a1.126 1.126 0 0 1 1.95 0l8.997 15.583a1.126 1.126 0 0 1-.975 1.689z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCCC50",
    d: "M12 3.961a.74.74 0 0 1 .65.375l8.997 15.584a.75.75 0 0 1-.65 1.126H3.003a.75.75 0 0 1-.65-1.126L11.35 4.336a.74.74 0 0 1 .65-.375m0-.75a1.49 1.49 0 0 0-1.3.75L1.703 19.545a1.5 1.5 0 0 0 1.3 2.251h17.994a1.5 1.5 0 0 0 1.3-2.25L13.299 3.96a1.49 1.49 0 0 0-1.3-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M12 18.875a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M12.75 9.125a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z"
  })));
};
export default SvgIconWarningYellow;